buyBonusButton = {};

buyBonusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button._potBonusActive = false;

  button._flags.credit = {
    balance: 0,
  };

  button.canEnable = function () {
    if (Reflex.developerMode) {
      return true;
    }
    if (checkForUndefined(this.gameConfig)) return false;

    // latest libs we don't check stakes - just make sure we have data for the buy a bonus modes
    const buyBonusDataFireball =
      this.gameConfig.data.slotConfig.gameModes.FIREBALL_BUY;
    const buyBonusDataFreeSpins =
      this.gameConfig.data.slotConfig.gameModes.FREESPINS_BUY;

    let validStake = false;
    if (
      (buyBonusDataFireball !== undefined ||
        buyBonusDataFreeSpins !== undefined) &&
      (buyBonusDataFireball.coinSizes.length !== 0 ||
        buyBonusDataFreeSpins.coinSizes.length !== 0)
    ) {
      validStake = true;
    }

    var canEnable =
      this._flags.infoPlatformEnabled &&
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !button._sideMenuOpen &&
      validStake &&
      !button.isPromotion;

    resourceManager.get(this.name + ":button").alpha = canEnable ? 1 : 0.5;

    return canEnable;
  };

  button.canShow = function () {
    if (Reflex.developerMode) {
      return true;
    }
    if (checkForUndefined(this.gameConfig)) return false;
    const buyBonusDataFireball =
      this.gameConfig.data.slotConfig.gameModes.FIREBALL_BUY;
    const buyBonusDataFreeSpins =
      this.gameConfig.data.slotConfig.gameModes.FREESPINS_BUY;

    return (
      (buyBonusDataFireball !== undefined ||
        buyBonusDataFreeSpins !== undefined) &&
      this._flags.infoPlatformVisible &&
      gdk.getRegulatedMarket() !== "UK" &&
      !button._potBonusActive
    );
  };

  button.onPressedCallback = function () {
    // disable lucky bet button

    buyBonusPopup.show(function () {});
    if (button.soundName !== "") button.playSound();
  };

  button.onGameConfig = function (event) {
    this.gameConfig = event;
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.onStakeChanged = function (stake) {
    this._flags.stake = stake;
  };

  button.promotionStarted = function () {
    button.isPromotion = true;
  };

  button.promotionEnded = function () {
    button.isPromotion = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  button.onPotBonusStartEvent = function () {
    button._potBonusActive = true;
  };

  button.onPotBonusStartEventDead = function () {
    button._potBonusActive = false;
  };

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );
  messageBus.subscribe(
    "common:BalanceEvent",
    button.onCreditChanged.bind(button)
  );
  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onGameConfig.bind(button)
  );
  messageBus.subscribe(
    "stake:stakeChanged",
    button.onStakeChanged.bind(button)
  );
  messageBus.subscribe(
    "common:PromotionStarted",
    button.promotionStarted.bind(button)
  );
  messageBus.subscribe(
    "common:PromotionEnded",
    button.promotionEnded.bind(button)
  );

  messageBus.subscribe(
    "8bof:PotBonusStartEvent",
    button.onPotBonusStartEvent.bind(this)
  );
  messageBus.subscribe(
    "8bof:PotBonusStartEventDead",
    button.onPotBonusStartEventDead.bind(this)
  );

  return button;
};

buyBonusButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
buyBonusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusButton",
  buyBonusButton.create,
  buyBonusButton.initialise,
  buyBonusButton.getFilesRequired
);
